import axiosInstance from './axiosInstance';

export const createSalesEditRequest = (request) =>
    axiosInstance.post("/SalesEdit/CreateRequest", request);

export const approveSalesEditRequest = (requestId) =>
    axiosInstance.put("/SalesEdit/ApproveRequest", { requestId });

export const rejectSalesEditRequest = (requestId, remarks) =>
    axiosInstance.put("/SalesEdit/RejectRequest", { requestId, remarks });

export const getPendingSalesEditRequests = () =>
    axiosInstance.get("/SalesEdit/GetPendingRequests");

export const getAllSalesEditRequests = () =>
    axiosInstance.get("/SalesEdit/GetAllRequests");

export const getPendingSalesEditCount = () =>
    axiosInstance.get("/SalesEdit/GetPendingCount");
